export default {
    baseStyle: (props) => ({
        parts: [],
        container: {
            display: {base: 'grid'},
            gridTemplateColumns: {base: '39px 1fr auto'},
            gap: {base: 2},
            mb: {base: 6}
        },
        icon: {
            textAlign: 'center'
        },
        name: {
            textStyle: "webH4",
            mb: {base: 2}
        },
        typo: {
            textStyle: 'bodySmRegular'
        },
        costWrapper: {
            ml: {base: 10, lg: 20}
        },
        cost: {
            textStyle: 'bodySmRegular',
            textTransform: 'uppercase'
        }
    })
}
